/**
 * The route segment for the Shopee Affiliate connect page (AnyMindGroup/anyx#1752).
 *
 * Other modules use their `MarketplaceSaleChannelType` member for both the route `path` and the
 * picker's link, so the two agree by construction. An affiliate grant has no enum member, and
 * `createPath` answers a mismatch by silently falling back to the default route — so the route and
 * the link read this one symbol instead of two literals.
 */
export const SHOPEE_AFFILIATE_CHANNEL_TYPE = 'ShopeeAffiliate';
